import { JourneySkeleton } from '@/features/journey/components/journey-skeleton'
import { PlanPageSkeletonSuspense } from '@/features/plan/components/plan-page-skeleton'
import { useUser } from '@/features/plan/hooks/use-plan-data'
import { ContentFormat } from '@/generated/graphql'
import { PageSpinner } from '@/shared/components/layout/suspense-wrappers'

// Route-level loading fallback. Matches the skeleton to the active plan when
// it's known; while the plan type is still unknown, shows a neutral loader
// rather than the carousel skeleton (which would flash before the journey one).
export function PlanRouteFallback() {
  const { data, isLoading } = useUser()
  const activePlan =
    data?.me.availablePlans.find((p) => p.id === data?.me.activePlanId) ??
    data?.me.availablePlans[0]

  if (activePlan?.contentFormat === ContentFormat.Journey) {
    return <JourneySkeleton />
  }
  if (isLoading) {
    return <PageSpinner />
  }
  return <PlanPageSkeletonSuspense />
}
